import { ENROLLMENT_STORAGE_KEY } from './enrollmentPersistence'
import { enrollmentDraftStorageKeys } from '../utils/enrollmentDraftKeys'

const enrollmentBrowserStorageKeys = [
  ENROLLMENT_STORAGE_KEY,
  'enrollment-session-token',
  'resume-enrollment',
  'user-profile',
  ...enrollmentDraftStorageKeys
] as const

export const clearEnrollmentBrowserState = () => {
  if (typeof window === 'undefined') return

  for (const key of enrollmentBrowserStorageKeys) {
    window.sessionStorage.removeItem(key)
  }
}
